export const DialogSessionExpiredProperties = {
  imgPath: '../../../../assets/session-expired.svg',
};

export interface DialogSessionExpiredPropertiesTags {
  imgPath: string;
}
